module.exports = __webpack_public_path__ + "img/case3.9e6fc5d6.png";